import { DOCUMENT } from '@angular/common';
import {
  Component,
  ElementRef,
  HostListener,
  Inject,
  Input,
  OnInit,
  ViewChild,
} from '@angular/core';
import { Router } from '@angular/router';
import { position } from '../../../shared/utilities/Constants';

@Component({
  standalone: false,
  selector: 'mm-tooltip',
  templateUrl: './tooltip.component.html',
  styleUrls: ['./tooltip.component.scss'],
})
export class TooltipComponent implements OnInit {
  @Input() position: position;
  @Input() containsLink: boolean;
  @Input() clickable: boolean;
  @Input() textTooltip: boolean;
  @Input() marginPosition: boolean = false;
  openTooltip: boolean = false;
  @ViewChild('tooltip') tooltip: ElementRef;

  constructor(
    private router: Router,
    @Inject(DOCUMENT) private document: Document
  ) {}

  ngOnInit(): void {}

  @HostListener('click', ['$event'])
  onClick(event: MouseEvent) {
    if (event.target instanceof HTMLAnchorElement === false) {
      // Temporary implementation for close button
      // Remove after Everest's new variant release
      if (this.openTooltip) {
        this.tooltipAction(!this.openTooltip);
        this.openTooltip = false;
        return;
      }
      this.tooltipAction(!this.openTooltip);
      return;
    }
    event.preventDefault();
    let target = <HTMLAnchorElement>event.target;
    // If external link
    if (target.host !== window.location.host) {
      window.open(target.href, '_blank');
      return;
    }
    this.router.navigate([target.pathname]);
  }

  changeTooltipState() {
    this.openTooltip = !this.openTooltip;
  }

  tooltipAction(val: boolean) {
    this.tooltip.nativeElement
      .querySelector(
        '#top-tooltip-container, #bottom-tooltip-container, #right-tooltip-container, #text-tooltip-primary-container'
      )
      .setAttribute('aria-expanded', `${val}`);
  }

  get tooltipSdpsId(): string {
    if (this.textTooltip) {
      return 'text-tooltip-primary';
    }
    return 'top-tooltip';
  }

  get tooltipTopic(): string {
    if (this.textTooltip) {
      return 'text-tooltip-primary-topic';
    }
    return 'top-tooltip-topic';
  }
}
